/**
 * Created by Administrador on 10/08/2017.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .controller('publishedFaresController', publishedFaresController)
        .controller('publishFaresController', publishFaresController)
        .controller('generateFaresController', generateFaresController)
        .controller('generateTaxesController', generateTaxesController)
        .controller('pruebasController', pruebasController);

    publishedFaresController.$inject = [];
    publishFaresController.$inject = ['farePublishService', '$uibModalInstance'];
    generateFaresController.$inject = ['farePublishService', '$uibModalInstance'];
    generateTaxesController.$inject = ['farePublishService', '$uibModalInstance'];
    pruebasController.$inject = ['generalManifesto','$window','$sce','$timeout'];

    function publishedFaresController() {
    }

    function publishFaresController(farePublishService, $uibModalInstance) {
        var vm = this;

        vm.publish = function () {
            farePublishService.publishFares('fare-engine')
                .then(function () {
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    function generateFaresController(farePublishService, $uibModalInstance) {
        var vm = this;

        vm.generate = function () {
            farePublishService.generateFares()
                .then(function () {
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    function generateTaxesController(farePublishService, $uibModalInstance) {
        var vm = this;

        vm.generate = function () {
            farePublishService.generateTaxes()
                .then(function () {
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    function pruebasController(generalManifesto,$window,$sce,$timeout) {
        var vm = this;

        var file = new Blob([generalManifesto.data], {type: 'application/pdf;base64'});
        var fileURL = URL.createObjectURL(file);
        //vm.data =$sce.trustAsResourceUrl(fileURL);
        $window.open(fileURL);
    }
})();
